module.exports = __webpack_public_path__ + "img/system.b8423c6b.svg";